import { render, staticRenderFns } from "./SongDeleteCard.vue?vue&type=template&id=f1553236&"
import script from "./SongDeleteCard.vue?vue&type=script&lang=js&"
export * from "./SongDeleteCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports